/**
 * @generated SignedSource<<93097424b223ef22273c2c886d297f28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoShortCarouselCard$data = {
  readonly entityId: string;
  readonly headline: string | null | undefined;
  readonly images: ReadonlyArray<{
    readonly portraitStyle: {
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly socialHeadline: string | null | undefined;
  readonly youtubeId: string | null | undefined;
  readonly " $fragmentType": "videoShortCarouselCard";
};
export type videoShortCarouselCard$key = {
  readonly " $data"?: videoShortCarouselCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoShortCarouselCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoShortCarouselCard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "youtubeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": "portraitStyle",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "portrait"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"portrait\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
};

(node as any).hash = "c629c3d74626e3d928834d10ec8f89b2";

export default node;
